// Shared Mental Wellness therapist data + backend normalizer (ported from mobile).
export const SAMPLE_THERAPISTS = [
  {
    id: "sample-rhea", full_name: "Dr. Rhea Mehta", title: "Clinical Psychologist", category: "Psychologist",
    profile_photo: "https://images.unsplash.com/photo-1609371497456-3a55a205d5eb?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    rating: 4.9, reviews: 320, experience_years: 6, sessions: 500, audience: "Adults & Adolescents",
    tags: ["Anxiety", "Stress", "Life Transitions"],
    specialisations: ["Anxiety", "Stress Management", "Depression", "Self-esteem", "Relationship Issues", "Life Transitions"],
    languages: ["English", "Hindi", "Punjabi"], fee: 1200, session_mins: 50, availability: "Available now",
    offers_video: true, offers_audio: true, offers_in_person: true,
    clinic_locations: [
      { id: "rhea-ggn", name: "MindWell Clinic", address: "2nd Floor, Galleria Market, DLF Phase 4", city: "Gurugram" },
      { id: "rhea-sdelhi", name: "Serene Minds Centre", address: "A-12, South Extension Part II", city: "New Delhi" },
    ],
    about: "I help individuals manage anxiety, stress, low mood and life transitions through evidence-based therapies in a safe and supportive space.",
    is_sample: true,
  },
  {
    id: "sample-ananya", full_name: "Ms. Ananya Sharma", title: "Counsellor", category: "Counsellor",
    profile_photo: "https://images.unsplash.com/photo-1655249493799-9cee4fe983bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    rating: 4.8, reviews: 210, experience_years: 4, sessions: 320, audience: "Adults",
    tags: ["Relationship", "Self-esteem", "Career"],
    specialisations: ["Relationship Issues", "Self-esteem", "Career", "Work Stress", "Confidence"],
    languages: ["English", "Hindi"], fee: 900, session_mins: 45, availability: "Available now",
    offers_video: true, offers_audio: true, offers_in_person: false,
    about: "A warm, non-judgemental counsellor helping you navigate relationships, self-esteem and career decisions with clarity and confidence.",
    is_sample: true,
  },
  {
    id: "sample-kabir", full_name: "Dr. Kabir Sethi", title: "Psychiatrist", category: "Psychiatrist",
    profile_photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    rating: 4.9, reviews: 280, experience_years: 8, sessions: 640, audience: "Adults",
    tags: ["Depression", "Anxiety", "Sleep Issues"],
    specialisations: ["Depression", "Anxiety", "Sleep Issues", "Mood Disorders", "Medication Management"],
    languages: ["English", "Hindi"], fee: 1500, session_mins: 30, availability: "Available today",
    offers_video: true, offers_audio: true, offers_in_person: true,
    clinic_locations: [
      { id: "kabir-cp", name: "Sethi Neuropsychiatry Clinic", address: "Block C, Connaught Place", city: "New Delhi" },
      { id: "kabir-noida", name: "CalmCare Hospital", address: "Sector 18", city: "Noida" },
    ],
    about: "Board-certified psychiatrist with 8 years of experience in mood, anxiety and sleep disorders, offering compassionate, personalised care.",
    is_sample: true,
  },
  {
    id: "sample-neha", full_name: "Ms. Neha Kapoor", title: "Therapist", category: "Therapist",
    profile_photo: "https://images.unsplash.com/photo-1609436132311-e4b0c9370469?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    rating: 4.7, reviews: 160, experience_years: 5, sessions: 410, audience: "Adults & Families",
    tags: ["Stress", "Grief", "Family Support"],
    specialisations: ["Stress", "Grief", "Family Support", "Emotional Wellbeing"],
    languages: ["English", "Hindi"], fee: 1000, session_mins: 50, availability: "Available today",
    offers_video: true, offers_audio: false, offers_in_person: true,
    clinic_locations: [{ id: "neha-blr", name: "Harmony Therapy Space", address: "100 Ft Road, Indiranagar", city: "Bengaluru" }],
    about: "I provide a calm, empathetic space to work through stress, grief and family challenges, helping you build resilience and emotional balance.",
    is_sample: true,
  },
  {
    id: "sample-aisha", full_name: "Dr. Aisha Khan", title: "Psycho-Oncologist", category: "Psychologist",
    profile_photo: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    rating: 4.9, reviews: 180, experience_years: 9, sessions: 540, audience: "Cancer patients & families",
    tags: ["Psycho-Oncology", "Coping with Diagnosis"],
    specialisations: ["Psycho-Oncology", "Coping with Diagnosis", "Treatment Stress", "Anxiety", "Fear of Recurrence"],
    languages: ["English", "Hindi", "Urdu"], fee: 1400, session_mins: 50, availability: "Available today",
    offers_video: true, offers_audio: true, offers_in_person: true,
    clinic_locations: [{ id: "aisha-mum", name: "Hope Oncology Wellness", address: "Hill Road, Bandra West", city: "Mumbai" }],
    conditions: ["Cancer"],
    about: "I support people through every stage of a cancer journey from diagnosis and treatment to survivorship with warmth and evidence-based care.",
    is_sample: true,
  },
  {
    id: "sample-vikram", full_name: "Dr. Vikram Rao", title: "Palliative Care Counsellor", category: "Counsellor",
    profile_photo: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    rating: 4.8, reviews: 140, experience_years: 11, sessions: 610, audience: "Serious & terminal illness",
    tags: ["Palliative Counselling", "End-of-life Support"],
    specialisations: ["Palliative Counselling", "Pain-related Distress", "End-of-life Support", "Dignity & Meaning", "Family Conversations"],
    languages: ["English", "Hindi"], fee: 1300, session_mins: 50, availability: "Available this week",
    offers_video: true, offers_audio: true, offers_in_person: false,
    conditions: ["Cancer", "Chronic Pain", "Heart Failure", "Kidney / Dialysis"],
    about: "I help patients and families facing serious illness find comfort, meaning and calm, and navigate difficult decisions with compassion.",
    is_sample: true,
  },
  {
    id: "sample-leela", full_name: "Ms. Leela Nair", title: "Medical Social Worker & Counsellor", category: "Counsellor",
    profile_photo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    rating: 4.7, reviews: 95, experience_years: 7, sessions: 300, audience: "Patients & caregivers",
    tags: ["Caregiver Support", "Treatment Navigation"],
    specialisations: ["Caregiver Support", "Treatment Navigation", "Financial & Practical Stress", "Emotional Support"],
    languages: ["English", "Hindi", "Malayalam"], fee: 900, session_mins: 45, availability: "Available today",
    offers_video: true, offers_audio: true, offers_in_person: false,
    conditions: ["Cancer", "Kidney / Dialysis", "Caregivers", "Neurological"],
    about: "I walk alongside patients and caregivers to ease the practical and emotional weight of a serious diagnosis.",
    is_sample: true,
  },
  {
    id: "sample-priya", full_name: "Dr. Priya Menon", title: "Health Psychologist", category: "Psychologist",
    profile_photo: "https://images.unsplash.com/photo-1582750433449-648ed127bb54?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    rating: 4.8, reviews: 160, experience_years: 8, sessions: 420, audience: "Chronic illness",
    tags: ["Chronic Illness", "Pain Management"],
    specialisations: ["Chronic Illness Adjustment", "Pain Management", "Health Anxiety", "Lifestyle & Coping", "Diabetes Distress"],
    languages: ["English", "Hindi", "Tamil"], fee: 1200, session_mins: 50, availability: "Available this week",
    offers_video: true, offers_audio: true, offers_in_person: true,
    clinic_locations: [{ id: "priya-blr", name: "Wellbeing Health Psychology", address: "Koramangala 5th Block", city: "Bengaluru" }],
    conditions: ["Chronic Pain", "Diabetes Distress", "Neurological", "Kidney / Dialysis", "Heart Failure"],
    about: "I help people adjust to life with a chronic condition, manage the mental load of illness, and reclaim a sense of control and hope.",
    is_sample: true,
  },
];

export function normalizeConsultant(c) {
  const svc = Array.isArray(c.service_types) ? c.service_types : [];
  const titleLc = (c.title || "").toLowerCase();
  return {
    id: c.id,
    full_name: c.full_name || "Professional",
    title: c.title || "Mental Health Professional",
    category: titleLc.includes("psychiatr") ? "Psychiatrist"
      : titleLc.includes("psycholog") ? "Psychologist"
      : titleLc.includes("counsel") ? "Counsellor" : "Therapist",
    profile_photo: c.profile_photo || "",
    rating: c.rating || 0,
    reviews: c.reviews_count || c.total_reviews || 0,
    experience_years: c.experience_years || 0,
    sessions: c.total_sessions || 0,
    audience: c.audience || "Adults",
    tags: svc.slice(0, 3),
    specialisations: svc,
    languages: Array.isArray(c.languages) ? c.languages : ["English"],
    fee: c.video_session_fee || c.chat_session_fee || 0,
    session_mins: c.session_duration_mins || 50,
    availability: c.is_available ? "Available now" : "Available today",
    offers_video: c.offers_video !== false,
    offers_audio: c.offers_chat !== false,
    offers_in_person: !!c.offers_in_person,
    clinic_locations: Array.isArray(c.clinic_locations) && c.clinic_locations.length
      ? c.clinic_locations.map((l, i) => ({ id: l.id || `loc-${i}`, name: l.name || l.clinic_name || "Clinic", address: l.address || "", city: l.city || c.city || "" }))
      : (c.clinic_address ? [{ id: "primary", name: c.clinic_name || "Clinic", address: c.clinic_address, city: c.city || "" }] : []),
    conditions: Array.isArray(c.conditions) && c.conditions.length ? c.conditions : undefined,
    about: c.bio || "",
    is_sample: false,
  };
}

// Local (device) session store — mirrors the mobile mw_local_sessions behaviour.
const LS_KEY = "mw_local_sessions";
export function getLocalSessions() {
  try { return JSON.parse(localStorage.getItem(LS_KEY) || "[]"); } catch { return []; }
}
export function saveLocalSessions(list) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(list)); } catch { /* ignore */ }
}
